/**
 * Shopify Forms: <label for="label-custom#message"> must pair with
 * <textarea id="label-custom#message">. The app may wrongly put that id on the
 * label and leave the textarea as name="custom#message" only — fix after hydrate.
 * Also corrects the same pattern inside <shopify-forms-embed> shadow roots.
 *
 * Placeholder text from the Forms app (e.g. #909090) can fall below 4.5:1 on white.
 * Floating labels use the same grey on the label element (not ::placeholder).
 * We inject WCAG-friendly color: black at 61% opacity (~4.54:1 on #fff), with
 * !important. Styles must stay last in each shadow root so later app CSS cannot win.
 * Light-DOM rules are scoped to .app-wrapper / .section-app-wrapper so theme floating
 * labels (transparent ::placeholder) elsewhere are not affected.
 */
(function () {
  var MESSAGE_CONTROL_ID = 'label-custom#message';
  var MESSAGE_NAME = 'custom#message';
  var PLACEHOLDER_STYLE_ID = 'shopify-forms-placeholder-contrast';
  var PLACEHOLDER_DOC_STYLE_ID = 'shopify-forms-placeholder-contrast-doc';

  /** Rules for inside shadow roots only (only form controls exist there). */
  function contrastCssShadow() {
    return (
      'input::placeholder,textarea::placeholder,select::placeholder{' +
      'color:rgba(0,0,0,.61)!important;opacity:1!important;}' +
      'input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{' +
      'color:rgba(0,0,0,.61)!important;opacity:1!important;}' +
      'input::-moz-placeholder,textarea::-moz-placeholder{' +
      'color:rgba(0,0,0,.61)!important;opacity:1!important;}' +
      'label[class*="_formInputFieldLabel"],' +
      '[class*="_formInputFieldLabel"],' +
      '[class*="_formInputFieldLabel"] *{' +
      'color:rgba(0,0,0,.61)!important;opacity:1!important;}'
    );
  }

  /**
   * Light-DOM forms inside app sections only — avoids overriding theme floating-label
   * inputs that use transparent ::placeholder (e.g. .field pattern elsewhere).
   */
  function contrastCssDocumentScoped() {
    var roots = ['.app-wrapper', '.section-app-wrapper'];
    var placeholders = [
      'input::placeholder',
      'textarea::placeholder',
      'select::placeholder',
      'input::-webkit-input-placeholder',
      'textarea::-webkit-input-placeholder',
      'input::-moz-placeholder',
      'textarea::-moz-placeholder'
    ];
    var labels = [
      'label[class*="_formInputFieldLabel"]',
      '[class*="_formInputFieldLabel"]',
      '[class*="_formInputFieldLabel"] *'
    ];
    var selPlaceholder = [];
    var selLabels = [];
    var i;
    var j;
    for (i = 0; i < roots.length; i++) {
      for (j = 0; j < placeholders.length; j++) {
        selPlaceholder.push(roots[i] + ' ' + placeholders[j]);
      }
      for (j = 0; j < labels.length; j++) {
        selLabels.push(roots[i] + ' ' + labels[j]);
      }
    }
    return (
      selPlaceholder.join(',') +
      '{color:rgba(0,0,0,.61)!important;opacity:1!important;}' +
      selLabels.join(',') +
      '{color:rgba(0,0,0,.61)!important;opacity:1!important;}'
    );
  }

  function injectPlaceholderContrast(shadowRoot) {
    if (!shadowRoot) return;

    var style = shadowRoot.getElementById(PLACEHOLDER_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = PLACEHOLDER_STYLE_ID;
      style.textContent = contrastCssShadow();
      shadowRoot.appendChild(style);
    } else {
      // App stylesheets added after ours win at equal specificity; keep last.
      shadowRoot.appendChild(style);
    }
  }

  function injectDocumentContrast() {
    var style = document.getElementById(PLACEHOLDER_DOC_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = PLACEHOLDER_DOC_STYLE_ID;
      style.textContent = contrastCssDocumentScoped();
      document.head.appendChild(style);
    } else {
      document.head.appendChild(style);
    }
  }

  function findMessageTextarea(label) {
    if (!label) return null;

    var p = label.parentElement;
    var depth = 0;
    while (p && depth < 16) {
      var scoped = p.querySelector('textarea[name="' + MESSAGE_NAME + '"]');
      if (scoped instanceof HTMLTextAreaElement && p.contains(label)) {
        return scoped;
      }
      p = p.parentElement;
      depth++;
    }

    var globalNamed = document.querySelectorAll(
      'textarea[name="' + MESSAGE_NAME + '"]'
    );
    if (globalNamed.length === 1) return globalNamed[0];

    var ta =
      label.parentElement && label.parentElement.querySelector('textarea');
    if (ta) return ta;

    var node = label.nextElementSibling;
    while (node) {
      if (node.tagName === 'TEXTAREA') return node;
      if (node.querySelector) {
        ta = node.querySelector('textarea');
        if (ta) return ta;
      }
      node = node.nextElementSibling;
    }

    node = label.previousElementSibling;
    while (node) {
      if (node.tagName === 'TEXTAREA') return node;
      if (node.querySelector) {
        ta = node.querySelector('textarea');
        if (ta) return ta;
      }
      node = node.previousElementSibling;
    }

    var container =
      label.closest('[class*="field"]') ||
      label.closest('[class*="Field"]') ||
      label.closest('form');
    if (container) {
      var list = container.querySelectorAll('textarea');
      if (list.length === 1) return list[0];
      for (var i = 0; i < list.length; i++) {
        var name = (list[i].getAttribute('name') || '').toLowerCase();
        if (name.indexOf('message') !== -1) return list[i];
      }
      return list.length ? list[list.length - 1] : null;
    }

    return null;
  }

  function findMessageLabel() {
    return (
      document.querySelector('label[for="' + MESSAGE_CONTROL_ID + '"]') ||
      document.querySelector('label[id="' + MESSAGE_CONTROL_ID + '"]')
    );
  }

  function tryLinkMessageField() {
    var label = findMessageLabel();
    if (!label) return;

    var ta = findMessageTextarea(label);
    if (!(ta instanceof HTMLTextAreaElement)) return;

    // Id belongs on the textarea only, not on the label.
    if (label.id === MESSAGE_CONTROL_ID) {
      label.removeAttribute('id');
    }

    if (ta.id === MESSAGE_CONTROL_ID) return;

    var el;
    while ((el = document.querySelector('[id="' + MESSAGE_CONTROL_ID + '"]'))) {
      if (el === ta) break;
      el.removeAttribute('id');
    }

    ta.id = MESSAGE_CONTROL_ID;
  }

  function fixInsideShadow() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (!host.shadowRoot) continue;

      injectPlaceholderContrast(host.shadowRoot);

      var root = host.shadowRoot;
      var textarea = root.querySelector(
        'textarea[name="' + MESSAGE_NAME + '"]'
      );
      var label =
        root.querySelector('label[for="' + MESSAGE_CONTROL_ID + '"]') ||
        root.querySelector('label[id="' + MESSAGE_CONTROL_ID + '"]') ||
        root.querySelector('#label-custom\\#message');

      if (!textarea || !label) continue;

      label.removeAttribute('id');
      textarea.id = MESSAGE_CONTROL_ID;
      label.setAttribute('for', MESSAGE_CONTROL_ID);
    }
  }

  function runAll() {
    injectDocumentContrast();
    tryLinkMessageField();
    fixInsideShadow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  var obs = new MutationObserver(runAll);
  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  }

  var shadowPoll = setInterval(fixInsideShadow, 1000);

  // Forms embed can hydrate after first paint; keep re-ordering our stylesheet ahead of late app CSS.
  setTimeout(function () {
    obs.disconnect();
    clearInterval(shadowPoll);
  }, 300000);
})();
